/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';

import PropTypes from 'prop-types';

// REDUX
import { connect } from 'react-redux';
import * as dataActions from '../../redux/actions/data';

import styles from './LargeCarousel.module.scss';

const shareIcon = require('./imgs/share-icon.svg');

class HighlightsCarousel extends Component {
  constructor(props) {
    super(props);
    this.carousel = React.createRef();
    this.finalCard = React.createRef();
  }

  componentDidMount() {
    const { cards } = this.props;
    const finalCardPosition = this.finalCard.current.getBoundingClientRect().left;
    const width = this.returnContainerWidth(cards) - 425;
    this.carousel.current.addEventListener('scroll', () => {
      const { readIndex, setReadIndex } = this.props;
      const scrollLeft = Math.floor(this.carousel.current.scrollLeft);
      const scrolledIndex = Math.floor(cards.length * (scrollLeft / width));
      if (scrolledIndex > readIndex) setReadIndex(scrolledIndex);
      if (scrollLeft >= finalCardPosition) setReadIndex(cards.length);
    });
  }

  /**
   * Returns formatted width depending on cards object length
   * @param {Object} card - card object
   */
  returnContainerWidth = (cards) => (
    window.innerWidth * .96 * (cards.length + 1) // eslint-disable-line
  );

  /**
   * Scroll to beginning of element
   */
  scrollToBeginning = () => {
    this.carousel.current.scrollLeft = 0;
  }

  render() {
    const { cards, onShare, readIndex } = this.props;
    return (
      <div
        ref={this.carousel}
        className={styles.cardCarouselWrapper}
      >
        <div
          style={{ width: this.returnContainerWidth(cards) }}
          className={styles.cardCarouselContainer}
        >
          {cards.map(({ company, title, body }, index) => (
            <div
              key={body}
              className={[
                styles.cardContainer,
                (index < readIndex) ? styles.readCardContainer : null,
              ].join(' ')}
            >
              <div className={styles.cardHeader}>
                <div>
                  <p>{company}</p>
                  <p>{title}</p>
                </div>
                <p>{`${index + 1} of ${cards.length}`}</p>
              </div>
              <h2 dangerouslySetInnerHTML={{ __html: body }} /> {/* eslint-disable-line */}
              <span className={styles.shareContainer}>
                <img onClick={onShare} alt="car-icon" src={shareIcon} />
              </span>
            </div>
          ))}
          <div
            ref={this.finalCard}
            className={styles.finalCard}
          >
            <h2>You&apos;re all caught up!</h2>
            <p onClick={this.scrollToBeginning}>Start Over</p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { readIndex } = state.data;
  return { readIndex };
};

const mapDispatchToProps = (dispatch) => ({
  setReadIndex: (value) => dispatch(dataActions.setReadIndex(value)),
});

HighlightsCarousel.propTypes = {
  cards: PropTypes.any.isRequired, // eslint-disable-line
  onShare: PropTypes.func.isRequired,
  setReadIndex: PropTypes.func.isRequired,
  readIndex: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(HighlightsCarousel);
